export default __webpack_public_path__ + "static/media/logo.b8c91274.png";